import * as L from 'leaflet';
import '../../MapStyles/MapIcons.scss';

const getBaseSVG = (type: string, color: string, size: number) => `
  <svg class="marker-svg" width="${size}" height="${size}" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M20 0 C28 0, 36 8, 36 16 C36 28, 20 40, 20 40 C20 40, 4 28, 4 16 C4 8, 12 0, 20 0 Z"
            fill="var(${color})" />
      <circle cx="20" cy="16" r="12" fill="white" />
      <foreignObject x="10" y="6" width="20" height="20">
        <i xmlns="http://www.w3.org/1999/xhtml"
           class="sonarIcon sonarIcon-${type} fw-semibold"
           style="
             color: var(${color});
             font-size: ${Math.round((size + 25) * 0.2)}px;
             display: flex;
             align-items: center;
             justify-content: center;
             width: 100%;
             height: 100%;
             text-align: center;
           ">
        </i>
      </foreignObject>
    </g>
  </svg>
`;

export const getMapIcon = (type: string, color: string, shadow: boolean, size: number) => {
  const svgContent = getBaseSVG(type, color, size);

  return L.divIcon({
    html: `
      <div class="marker-container ${
        shadow ? 'has-shadow' : ''
      }" style="width: ${size}px; height: ${size}px;">
        <div class="marker-ground-shadow"></div>
        ${svgContent}
      </div>
    `,
    className: '',
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
  });
};

export const getMapBubbleIcon = (
  type: string,
  color: string,
  shadow: boolean,
  cluster: L.MarkerCluster,
  size: number = 40,
) => {
  const svgContent = getBaseSVG(type, color, size);
  const count = cluster.getChildCount() < 999 ? cluster.getChildCount() : '999+';
  const bubbleFontSize = size * 0.25;
  const bubbleSize = size * 0.6;

  return L.divIcon({
    html: `
      <div class="marker-container ${
        shadow ? 'has-shadow' : ''
      }" style="width: ${size}px; height: ${size}px; position: relative;">
        <div class="marker-ground-shadow"></div>
        ${svgContent}
        <div class="cluster-bubble" style="
          position: absolute;
          top: -${size * 0.2}px;
          right: -${size * 0.2}px;
          background: #888;
          color: white;
          font-size: ${bubbleFontSize}px;
          width: ${bubbleSize}px;
          height: ${bubbleSize}px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          box-shadow: 0 2px 4px rgba(0,0,0,0.3);
          z-index: 2;
        ">${count}</div>
      </div>
    `,
    className: '',
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
  });
};
